import * as React from "react";
function SvgUserCircle(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M24 2.4c11.9 0 21.6 9.7 21.6 21.6S35.9 45.6 24 45.6 2.4 35.9 2.4 24 12.1 2.4 24 2.4M24 0C10.8 0 0 10.8 0 24s10.8 24 24 24 24-10.8 24-24c0-6.2-2.5-12.2-6.8-16.8C36.7 2.5 30.5 0 24 0zm3.8 25.6c4-2.3 5.3-7.3 3-11.2-2.3-4-7.3-5.3-11.2-3s-5.3 7.3-3 11.2c.7 1.3 1.9 2.4 3.2 3.1C15 27.1 12 31.3 12 37.1v1.3h7.2V36h-4.8c.5-6 5.2-8.4 9.6-8.4s9 2.4 9.6 8.4h-6v2.4H36v-1.3c0-5.9-3.1-10.1-8.2-11.5zM18 18.5c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8-2.6 5.8-5.8 5.8-5.8-2.6-5.8-5.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserCircle);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
